import React, { useEffect, useState } from 'react'
import landing from '../assest/landing.png'
import Aos from 'aos';
import "aos/dist/aos.css"
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

function Home () {
    const [home, setHome] = useState([]);
    const { t, i18n } = useTranslation();

    i18next.on('languageChanged', function (lng) {
        // تحديث اتجاه الصفحة بناءً على اللغة الحالية
        document.documentElement.setAttribute('dir', lng === 'ar' ? 'rtl' : 'ltr');
    });

    useEffect(() => {
        Aos.init();

        // fetch home
        const fetchLogo = async () => {
            const res = await fetch(`${process.env.REACT_APP_PROJECTS_API}components/s_d.php?logo`)
            const data = await res.json()
            return setHome(data);
        }
        fetchLogo()
    }, [])
    return (
        <section className='home' id='home'>

            <div className="container">
                {/* <div className="social">
                    <ul>
                        <li><a target='_blank' href="https://www.facebook.com/profile.php?id=61564897101260"><i className="fa fa-facebook-f"></i></a></li>
                        <li><a target='_blank' href="https://api.whatsapp.com/send/?phone=201066853530"><i className="fa fa-whatsapp"></i></a></li>
                    </ul>
                </div> */}

                <div className="content">
                    <div data-aos="fade-left" data-aos-duration="3000" className="text-area">
                        <div className="text">
                            <h1> <span>Logic Pharma</span> <br />
                                {i18n.language == "ar" ? "ﺍﺧﺘﻴﺎﺭ ﻣﻨﻄﻘﻲ ... ﺍﺧﺘﻴﺎﺭ ﻣﺜﺎﻟﻲ" : "Logical choice ..  Perfect choice"}
                            </h1>
                            <p>{i18n.language == "ar" ? "ﻳﻘﺪﻡ ﻣﺼﻨﻊ ﻟﻮﺟﻴﻚ ﻓﺎﺭﻣﺎ ﻣﺠﻤﻮﻋﺔ ﻣﺘﻜﺎﻣﻠﺔ ﻭﻣﺘﻨﻮﻋﻪ ﻣﻦ ﺍﻟﻤﻨﺘﺠﺎﺕ ﺍﻟﺘﻲ ﺗُﺴﺘﺨﺪﻡ ﻛﺎﺿﺎﻓﺎﺕ ﻟﺠﻤﻴﻊ ﺍﻧﻮﺍﻉ ﺍﻻﻋﻼﻑ ﺍﻭ ﻣﺎﺀ ﺍﻟﺸﺮﺏ ﺍﻟﺘﻲ ﺗﻘﺪﻡ ﺍﻟﻲ ﺟﻤﻴﻊ ﺍﻟﻄﻴﻮﺭ ﻭﺍﻟﺤﻴﻮﺍﻧﺎﺕ. ﻳﺮﻛﺰ ﺍﻟﻤﻮﻗﻊ ﻋﻠﻰ ﺗﻮﻓﻴﺮ ﻣﻌﻠﻮﻣﺎﺕ ﺷﺎﻣﻠﺔ ﺣﻮﻝ ﻣﻨﺘﺠﺎﺕ ﺍﻟﻤﺼﻨﻊ ﺍﻟﺘﻲ ﺗﺸﻤﻞ ﺍﻟﻔﻴﺘﺎﻣﻴﻨﺎﺕ، ﻭﺍﻟﻤﻌﺎﺩﻥ، ﻭﺍﻟﻤﻜﻤﻼﺕ ﺍﻟﻐﺬﺍﺋﻴﺔ ﻭﺍﻟﻤﻄﻬﺮﺍﺕ ﺍﻟﺘﻲ ﺗُﺤﺴﻦ ﺻﺤﺔ ﻭﺃﺩﺍﺀ ﺍﻟﺤﻴﻮﺍﻧﺎﺕ ﻭﺍﻟﻄﻴﻮﺭﻭﺍﻻﺳﻤﺎﻙ. ﻳُﺒﺮﺯ ﺍﻟﻤﻮﻗﻊ ﺃﻳﻀًﺎ ﺍﻟﺘﺰﺍﻡ ﺍﻟﻤﺼﻨﻊ ﺑﻤﻌﺎﻳﻴﺮ ﺍﻟﺠﻮﺩﺓ ﺍﻟﻌﺎﻟﻴﺔ ﻭﺍﻻﺑﺘﻜﺎﺭ ﻓﻲ ﺗﻄﻮﻳﺮ ﺇﺿﺎﻓﺎﺕ ﺍﻷﻋﻼﻑ ﺍﻟﺘﻲ ﺗﻠﺒﻲ ﺍﺣﺘﻴﺎﺟﺎﺕ ﺍﻟﺴﻮﻕ ﻭﺗﺴﺎﻫﻢ ﻓﻲ ﺩﻋﻢ ﺍﻹﻧﺘﺎﺝ ﺍﻟﺤﻴﻮﺍﻧﻲ ﻭﺍﻟﺪﺍﺟﻨﻲ ﺍﻟﻤﺴﺘﺪﺍﻡ." : "Logic Pharma Factory provides a comprehensive and diverse range of products used as additives for all types of feeding and drinking water for various birds, animals and fish. The website focuses on offering detailed information about the factories products including vitamins, minerals, nutritional supplements and disinfectants that enhance the health and performance of animals, birds and fish."}</p>
                            <div className="btns">
                                <button class="button type1">
                                    <span class="btn-txt"><a href="#services">{i18n.language == "ar" ? "كل المنتجات" : "All Products"}</a></span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div data-aos="fade-right" data-aos-duration="3000" className="image-area">
                        <div className="image">
                            <img src={landing} alt="" />
                        </div>
                    </div>
                </div>

                <div className="reviews">
                    <div class="counter">
                        <ul>
                            <li>
                                <div class="single-counter">
                                    <div class="content-review">
                                        <div class="number">
                                            <span className='icon'><svg xmlns="http://www.w3.org/2000/svg" height={'2rem'} viewBox="0 0 512 512"><path d="M352 256c0 22.2-1.2 43.6-3.3 64l-185.3 0c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64l185.3 0c2.2 20.4 3.3 41.8 3.3 64zm28.8-64l123.1 0c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64l-123.1 0c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32l-116.7 0c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0l-176.6 0c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0L18.6 160C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192l123.1 0c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64L8.1 320C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6l176.6 0c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352l116.7 0zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6l116.7 0z" /></svg></span>
                                        </div>
                                        <p>{i18n.language == "ar" ? "جودة عالمية" : "Global Quality"}</p>
                                    </div>
                                </div>
                            </li>
                            <li >
                                <div class="single-counter">
                                    <div class="content-review">
                                        <div class="number">
                                            <span className='icon'><svg xmlns="http://www.w3.org/2000/svg" height={"2rem"} viewBox="0 0 512 512"><path d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" /></svg></span>
                                        </div>
                                        <p>{i18n.language == "ar" ? "أسرع وقت" : "Fastest Time"}</p>
                                    </div>
                                </div>
                            </li>
                            <li >
                                <div class="single-counter">
                                    <div class="content-review">
                                        <div class="number">
                                            <span className='icon'><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 288 512"><path d="M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z" /></svg></span>
                                        </div>
                                        <p>{i18n.language == "ar" ? "اسعار تنافسية" : "Competitive Prices"}</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section >
    )
}

export default Home
